import React from 'react';
import ReactDOM from 'react-dom';
import Boss from './Boss';
import './index.scss';

ReactDOM.render(
  <Boss />,
  document.getElementById('root')
);
